/* global Uint8Array */
/* eslint quotes:0 */
'use strict';

// http://stackoverflow.com/questions/9267899/arraybuffer-to-base64-encoded-string
window._arrayBufferToBase64 = (buffer) => {
  let binary = '';
  let bytes = new Uint8Array(buffer);
  let len = bytes.byteLength;

  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
};

function inputBase64($window, $q) {
  let isolatedScope = {
    onChange: '&',
    onAfterValidate: '&',
    parser: '&'
  };
  let FILE_READER_EVENTS = [
    'onabort',
    'onerror',
    'onloadstart',
    'onloadend',
    'onprogress',
    'onload'
  ];

  for (let i = FILE_READER_EVENTS.length - 1; i >= 0; i--) {
    let e = FILE_READER_EVENTS[i];
    isolatedScope[e] = '&';
  }

  return {
    restrict: 'A',
    require: 'ngModel',
    scope: isolatedScope,
    link: (scope, el, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      let rawFiles = [];
      let fileObjects = [];

      function maxNumber(val) {
        if (attr.maxnum && attr.multiple && val) {
          let valid = val.length <= parseInt(attr.maxnum, 10);
          ctrl.$setValidity('maxnum', valid);
        }

        return val;
      }

      function minNumber(val) {
        if (attr.minnum && attr.multiple && val) {
          let valid = val.length >= parseInt(attr.minnum, 10);
          ctrl.$setValidity('minnum', valid);
        }

        return val;
      }

      function maxSize(val) {
        let valid = true;

        if (attr.maxsize && val) {
          let max = parseFloat(attr.maxsize) * 1000;

          if (attr.multiple) {
            for (let i = 0; i < val.length; i++) {
              let file = val[i];

              if (file.size > max) {
                valid = false;
                break;
              }
            }
          } else {
            valid = val.size <= max;
          }

          ctrl.$setValidity('maxsize', valid);
        }

        return val;
      }

      function minSize(val) {
        let valid = true;
        let min = parseFloat(attr.minsize) * 1000;

        if (attr.minsize && val) {
          if (attr.multiple) {
            for (let i = 0; i < val.length; i++) {
              let file = val[i];

              if (file.size < min) {
                valid = false;
                break;
              }
            }
          } else {
            valid = val.size >= min;
          }

          ctrl.$setValidity('minsize', valid);
        }

        return val;
      }

      function accept(val) {
        let valid = true;
        let regExp;
        let exp;
        let fileExt;

        if (attr.accept) {
          exp = attr.accept.trim().replace(/[,\s]+/gi, "|").replace(/\./g, "\\.").replace(/\/\*/g, "/.*");
          regExp = new RegExp(exp);
        }

        if (attr.accept && val) {
          if (attr.multiple) {
            for (let i = 0; i < val.length; i++) {
              let file = val[i];
              fileExt = '.' + file.filename.split('.').pop();
              valid = regExp.test(file.contentType) || regExp.test(fileExt);

              if (!valid) {
                break;
              }
            }
          } else {
            fileExt = '.' + val.filename.split('.').pop();
            valid = regExp.test(val.contentType) || regExp.test(fileExt);
          }

          ctrl.$setValidity('accept', valid);
        }

        return val;
      }

      function onChange(e) {
        if (attr.onChange) {
          scope.onChange()(e, rawFiles);
        }
      }

      function onAfterValidate(e) {
        if (attr.onAfterValidate) {
          // wait for all promises, in rawFiles, then call onAfterValidate
          let promises = [];

          for (let i = rawFiles.length - 1; i >= 0; i--) {
            promises.push(rawFiles[i].deferredObj.promise);
          }

          $q.all(promises).then(() => scope.onAfterValidate()(e, fileObjects, rawFiles));
        }
      }

      function readerOnLoad(fReader, file, fileObject) {
        return (e) => {
          let buffer = e.target.result;
          let promise;

          // do not convert the image to base64 if it exceeds the maximum size to prevent the browser from freezing
          let exceedsMaxSize = attr.maxsize && file.size > attr.maxsize * 1024;

          if (typeof attr.doNotParseIfOversize !== 'undefined' && exceedsMaxSize) {
            fileObject.base64 = null;
          } else {
            fileObject.base64 = $window._arrayBufferToBase64(buffer);
          }

          if (attr.parser) {
            promise = $q.when(scope.parser()(file, fileObject));
          } else {
            promise = $q.when(fileObject);
          }

          promise.then((fileObj) => {
            fileObjects.push(fileObj);
            file.deferredObj.resolve();
          });

          if (attr.onload) {
            scope.onload()(e, fReader, file, rawFiles, fileObjects, fileObject);
          }
        };
      }

      function attachHandlerForEvent(eventName, handler, fReader, file, fileObject) {
        fReader[eventName] = (e) => handler()(e, fReader, file, rawFiles, fileObjects, fileObject);
      }

      function attachEventHandlers(fReader, file, fileObject) {
        for (let i = FILE_READER_EVENTS.length - 1; i >= 0; i--) {
          let e = FILE_READER_EVENTS[i];

          // don't attach handler to onload yet
          if (attr[e] && e !== 'onload') {
            attachHandlerForEvent(e, scope[e], fReader, file, fileObject);
          }
        }

        fReader.onload = readerOnLoad(fReader, file, fileObject);
      }

      function _setViewValue() {
        let newVal = attr.multiple ? fileObjects : fileObjects[0];
        ctrl.$setViewValue(newVal);
        maxSize(newVal);
        minSize(newVal);
        maxNumber(newVal);
        minNumber(newVal);
        accept(newVal);
      }

      function readFiles() {
        let promises = [];
        let i;

        for (i = rawFiles.length - 1; i >= 0; i--) {
          // append file a new promise, that waits until resolved
          rawFiles[i].deferredObj = $q.defer();
          promises.push(rawFiles[i].deferredObj.promise);
        }

        // set view value once all files are read
        $q.all(promises).then(_setViewValue);

        for (i = rawFiles.length - 1; i >= 0; i--) {
          let reader = new $window.FileReader();
          let file = rawFiles[i];
          let fileObject = {};

          fileObject.contentType = file.type;
          fileObject.filename = file.name;
          fileObject.size = file.size;

          attachEventHandlers(reader, file, fileObject);
          reader.readAsArrayBuffer(file);
        }
      }

      el.on('change', function (e) {
        if (!e.target.files.length) {
          return;
        }

        fileObjects = [];
        fileObjects = angular.copy(fileObjects);
        // use event target so we can mock the files from test
        rawFiles = e.target.files;
        readFiles();
        onChange(e);
        onAfterValidate(e);
      });

      ctrl.$isEmpty = (val) => {
        return !val || (angular.isArray(val) ? val.length === 0 : !val.base64);
      };

      scope._clearInput = () => {
        el[0].value = '';
      };

      scope.$watch(() => {
        return ctrl.$viewValue;
      }, (val, oldVal) => {
        if (ctrl.$isEmpty(oldVal)) {
          return;
        }

        if (ctrl.$isEmpty(val)) {
          scope._clearInput();
        }
      });
    }
  };
}

inputBase64.$inject = ['$window', '$q'];

angular
  .module('sr.image64', [])
  .directive('inputBaseSixtyFour', inputBase64);
